import {
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Component,
    Inject,
    OnInit,
    ViewEncapsulation
} from '@angular/core';
import { KAL_DIALOG_DATA, KalDialogRef } from '@kalidea/kaligraphi';
import { GraphqlService } from 'src/app/_core/services/graphql.service';
import { BaseComponent } from 'src/app/_core/tools/base.component';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { FormValidator } from 'src/app/validators/form-validator';
import { UserState } from 'src/app/_user/store/user/user.state';
import { MutationReinitialiserMotPasseArgs } from 'src/graphql/generated-types';
import { catchError, tap } from 'rxjs/operators';
import gql from 'graphql-tag';
import { throwError } from 'rxjs';

export interface SharedResetPasswordDialogData {
    accepted?: boolean;
    beneficiaryId?: number;
    newPassword?: number;
}

@Component({
    selector: 'app-shared-reset-password-dialog',
    templateUrl: './shared-reset-password-dialog.component.html',
    styleUrls: ['./shared-reset-password-dialog.component.sass'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class SharedResetPasswordDialogComponent extends BaseComponent implements OnInit {

    form: UntypedFormGroup;

    constructor(private dialogRef: KalDialogRef<SharedResetPasswordDialogComponent>,
                @Inject(KAL_DIALOG_DATA) public data: SharedResetPasswordDialogData,
                protected cdr: ChangeDetectorRef,
                private graphqlService: GraphqlService,
                private fb: UntypedFormBuilder) {
        super(cdr);
    }

    get isStrongPasswordRequired(): boolean {
        return this.snapshot(UserState.applicationParameters).find(e => e.CodeChamp === 'AUTBNF').CodeValeur === '1';
    }

    close() {
        this.dialogRef.close();
    }

    submit() {
        if (this.data.beneficiaryId === 0) {
            this.dialogRef.close({
                accepted: true,
                newPassword: this.form.value?.NewPassword
            });
            return;
        }
        this.loading = true;

        this.watch$ = this.graphqlService.mutateOne<'ReinitialiserMotPasse', MutationReinitialiserMotPasseArgs>({
            mutation: gql`
                mutation ReinitialiserMotPasse(
                    $contexte: ContextInfosInput,
                    $idBenef: Float,
                    $NewPassword: String
                ) {
                    ReinitialiserMotPasse(
                        contexte: $contexte
                        idBenef: $idBenef
                        NewPassword: $NewPassword
                    )
                }
            `,
            variables: {
                idBenef: this.data.beneficiaryId,
                NewPassword: this.form.get('NewPassword').value
            }
        }).pipe(
            tap(() => {
                this.loading = false;
                this.data.accepted = true;
                this.dialogRef.close(this.data);
            }),
            catchError(err => {
                this.loading = false;
                return throwError(err);
            })
        );
    }

    ngOnInit(): void {
        this.form = this.fb.group({
            NewPassword: [''],
            ConfirmNewPassword: ['']
        }, {
            validator: [FormValidator.passwordRepeat('NewPassword', 'ConfirmNewPassword')]
        });

        let validator = Validators.minLength(5);

        if (this.isStrongPasswordRequired) {
            validator = FormValidator.passwordValidator;
        }

        this.form.get('NewPassword').setValidators(validator);
    }
}
